import React, { Fragment } from 'react';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import Featured from './Featured';
import Find from './Find';
import ListYourExperiance from './ListYourExperiance';
import Specialities from './Specialities';

const Home = () => {
  return (
    <Fragment>
      <Header />
      <Find />
      <Featured />
      <Specialities />
      <ListYourExperiance />
      <Footer />
    </Fragment>
  );
};

export default Home;